import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestImproveMessage } from "./improveMessage.request";
import {
  ImproveMessageRequestBody,
  ImproveMessageResponse
} from "./improveMessage.types";

const useImproveMessage = (
  options?: MutationOptions<
    ImproveMessageResponse,
    ApiServiceError<ApiError>,
    ImproveMessageRequestBody
  >
) => {
  return useMutation({
    mutationFn: requestImproveMessage,
    onError: toastServerError,
    ...options
  });
};

export default useImproveMessage;
